<template>
  <div id="app">
    <TopContents />
    <DownloadContents />
    <MovieContents />
    <SystemContents />
    <FooterContents />
  </div>
</template>

<script>
import TopContents from './components/TopContents';
import DownloadContents from './components/DownloadContents';
import MovieContents from './components/MovieContents';
import SystemContents from './components/SystemContents';
import FooterContents from './components/FooterContents';

export default {
  name: 'App',
  components: {
    TopContents,
    DownloadContents,
    MovieContents,
    SystemContents,
    FooterContents
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

body {
  background-color: #4d794d;
}

@font-face {
  font-family: 'kurobara';
  src: url(./assets/font/kurobara-cinderella.ttf);
}
</style>
